/* tl-cachebust-20260904-lineflick */
window.__tlLinePdp = window.__tlLinePdp || /\/products\/(sauteerpan|twee-handgrepen|wok-vlakke-bodem|hoge-rand|diepe-pan|crepepan|kookpan)(?:\/|$)/.test((location.pathname || '').toLowerCase());
if (window.__tlLinePdp) {
  window.__tgemSiteStickyBoot = true;
}

/* tl-cachebust-20260814-60set */

/* tl-dedupe-offer-boot-20260811f */
(function(){try{
  if (window.__tlLinePdp) return;
  var LABEL='2 producten 10% extra · 3 of meer 20% extra';
  function kill(){
    if (document.querySelector('#tl-sale-merch, [data-tl-sale-lp], .tl-sale')) {
      document.documentElement.classList.add('tl-sale-no-offer');
      document.querySelectorAll('.shopify-section.section-titanore-offer-bar, .titanore-offer-bar, .titanore-offer-bar .tob-inner').forEach(function(el){
        el.style.setProperty('display','none','important');
      });
      return;
    }
    document.querySelectorAll('#okhSummerStrip,#tlSummerStripLive').forEach(function(el){el.remove();});
    document.querySelectorAll('.shopify-section.section-titanore-top-offer').forEach(function(el){el.style.display='none';});
    var n=0; document.querySelectorAll('.shopify-section.section-titanore-offer-bar').forEach(function(el){n++; if(n>1) el.style.display='none';});
    var sale=document.querySelector('.titanore-offer-bar .tob-sale');
    if(sale){ sale.querySelectorAll('.tob-mark').forEach(function(m){m.remove();}); sale.textContent=LABEL; }
  }
  kill();
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', kill);
  setTimeout(kill,300); setTimeout(kill,1000);
}catch(e){}})();

/**
 * Sitewide Chef’s Pan sticky ATC
 * - GEM buybox pages: contrast + thumb only (native [data-tgem-sticky] owns UI)
 * - Chef’s Pan PDPs: match Small / Medium / Large
 * - GEM size UI present: sync selected size
 * - Everywhere else: Medium default (€100 / market presentment from buybox DOM)
 * cachebust-2026-08-10-sitewide7-king
 */
(function () {
  var pathEarly = (window.location.pathname || '').replace(/\/$/, '').toLowerCase();
  if (window.__tlLinePdp) return;
  if (/\/products\/(sauteerpan|twee-handgrepen|wok-vlakke-bodem|hoge-rand|diepe-pan|crepepan|kookpan)(?:\/|$)/.test(pathEarly)) return;
  /* Accessory / utensils-bundle PDPs — never treat as chefs-pan-set-3 prefix */
  if (/\/products\/[^/]*(ice-cube|straw|utensil)/.test(pathEarly)) return;
  /* TITANORE AB TEST — CHEFS PAN — VARIANT B owns its sticky; do not inject sitewide bar */
  if (pathEarly === '/pages/chefs-pan-b' || pathEarly === '/nl/pages/chefs-pan-b') return;
  if (pathEarly === '/pages/chefs-pan-tommy' || pathEarly === '/nl/pages/chefs-pan-tommy') return;
  if (pathEarly === '/collections/chefs-pan-tommy' || pathEarly === '/nl/collections/chefs-pan-tommy') return;
  if (pathEarly === '/collections/chefs-pan-tommy-b' || pathEarly === '/nl/collections/chefs-pan-tommy-b') return;
  if (pathEarly === '/pages/chef-sven-laurent' || pathEarly === '/nl/pages/chef-sven-laurent') return;
  if (pathEarly === '/pages/chefs-pan-sven' || pathEarly === '/nl/pages/chefs-pan-sven') return;
  if (/(?:^|[?&])view=chefs-pan-tommy(?:&|$)/.test(location.search || '')) return;
  if (document.querySelector && document.querySelector('.tl-tommy')) return;
  if (document.querySelector && document.querySelector('.tl-sven')) return;
  var isSetPdpEarly = /\/products\/chefs-pan-set-[23]$/.test(pathEarly);
  if (window.__tgemSiteStickyBoot && !isSetPdpEarly) return;
  if (window.__tgemSiteStickyBoot && isSetPdpEarly && document.documentElement.getAttribute('data-tl-sitewide-sticky') === 'sitewide9-set3') return;
  window.__tgemSiteStickyBoot = true;
  try {
    document.documentElement.setAttribute('data-tl-sitewide-sticky', 'sitewide9-set3');
  } catch (e) {}

  var path = pathEarly;

  /* Hosted checkout is not theme.liquid — still guard if ever injected */
  if (
    path.indexOf('/checkouts/') !== -1 ||
    path.indexOf('/checkout') !== -1 ||
    /\/(checkouts?|thank[_-]?you)/.test(path)
  ) {
    return;
  }

  var IMG = {
    small:
      'https://cdn.shopify.com/s/files/1/1009/4254/5283/files/RegularHammeredPantternPan26.webp?v=1776593863&width=160',
    medium:
      'https://cdn.shopify.com/s/files/1/1009/4254/5283/files/Standard_1.webp?v=1776593847&width=160',
    large:
      'https://cdn.shopify.com/s/files/1/1009/4254/5283/files/8c6248e5-ac9d-4c82-add8-74f7f9cd7061.webp?v=1781731283&width=160'
  };

  var CATALOG = {
    small: {
      label: 'Small · 26 cm',
      price: '€95',
      was: '€158',
      save: '€63',
      variantId: 57830475465091,
      href: '/products/titanium-hammered-pan-pro-small',
      img: IMG.small
    },
    medium: {
      label: 'Medium · 28 cm',
      price: '€100',
      was: '€167',
      save: '€67',
      variantId: 57830474842499,
      href: '/products/titanium-hammered-pan-pro-medium',
      img: IMG.medium
    },
    large: {
      label: 'Large · 30 cm',
      price: '€105',
      was: '€175',
      save: '€70',
      variantId: 57830473302403,
      href: '/products/titanium-hammered-pan-pro-large',
      img: IMG.large
    }
  };

  var SET_CATALOG = {
    'chefs-pan-set-2': {
      title: "Chef's Pan Set",
      titleNl: "Chef's Pan-set",
      label: 'Small + Medium',
      price: '€129',
      was: '€325',
      save: '€196',
      chip: '60% SUMMER DISCOUNT',
      variantId: 62341458723203,
      href: '/products/chefs-pan-set-2',
      img: 'https://cdn.shopify.com/s/files/1/1009/4254/5283/files/chefs-pan-set-2-small-medium.jpg?v=1786372983&width=160'
    },
    'chefs-pan-set-3': {
      title: "Chef's Pan Set",
      titleNl: "Chef's Pan-set",
      label: 'Small + Medium + Large',
      price: '€167.80',
      was: '€500',
      save: '€332.20',
      chip: '60% SUMMER DISCOUNT',
      variantId: 62341459116419,
      href: '/products/chefs-pan-set-3',
      img: 'https://cdn.shopify.com/s/files/1/1009/4254/5283/files/chefs-pan-set-3-small-medium-large.jpg?v=1789577962&width=160'
    }
  };

  var forcedSetKey = null;

  var CART_SECTION = 'cart-drawer';
  var forcedSizeKey = null;
  var sizeSyncEnabled = false;

  /* Prefer market labels from GEM buybox size buttons (single currency). Never invent €+£. */
  function hydrateCatalogFromBuybox() {
    document.querySelectorAll('.tgem-size[data-size], [data-tgem-sizes] [data-size]').forEach(function (btn) {
      var key = btn.getAttribute('data-size');
      if (!key || !CATALOG[key]) return;
      var price = btn.getAttribute('data-price');
      var was = btn.getAttribute('data-was');
      var save = btn.getAttribute('data-save');
      var href = btn.getAttribute('data-href');
      var variant = btn.getAttribute('data-variant');
      var img = btn.getAttribute('data-img');
      if (price) CATALOG[key].price = price;
      if (was) CATALOG[key].was = was;
      if (save) CATALOG[key].save = save;
      if (href) CATALOG[key].href = href;
      if (variant) CATALOG[key].variantId = parseInt(variant, 10) || CATALOG[key].variantId;
      if (img) CATALOG[key].img = img;
    });
  }

  function isGemLanding() {
    return (
      path === '/pages/shop-chefs-pan' ||
      path.endsWith('/pages/shop-chefs-pan') ||
      path === '/pages/chefs-pan' ||
      path.endsWith('/pages/chefs-pan') ||
      path === '/pages/chefs-pan-now' ||
      path.endsWith('/pages/chefs-pan-now') ||
      path === '/pages/buy-chefs-pan' ||
      path.endsWith('/pages/buy-chefs-pan') ||
      path === '/pages/get-chefs-pan' ||
      path.endsWith('/pages/get-chefs-pan') ||
      path === '/pages/chefs-pan-buy' ||
      path.endsWith('/pages/chefs-pan-buy')
    );
  }

  function pdpSizeFromPath() {
    if (path.indexOf('/products/titanium-hammered-pan-pro-small') !== -1) return 'small';
    if (path.indexOf('/products/titanium-hammered-pan-pro-medium') !== -1) return 'medium';
    if (path.indexOf('/products/titanium-hammered-pan-pro-large') !== -1) return 'large';
    return null;
  }

  function pdpSetFromPath() {
    var match = path.match(/\/products\/([^/?#]+)/);
    var handle = match ? decodeURIComponent(match[1]) : '';
    if (handle === 'chefs-pan-set-2') return 'chefs-pan-set-2';
    if (handle === 'chefs-pan-set-3') return 'chefs-pan-set-3';
    return null;
  }

  function hasNativeGemSticky() {
    return !!(
      document.querySelector('[data-tgem-sticky]') ||
      document.getElementById('tgem-shop-sticky')
    );
  }

  function injectContrastFix() {
    if (document.getElementById('tgem-sticky-contrast-fix')) return;
    var style = document.createElement('style');
    style.id = 'tgem-sticky-contrast-fix';
    style.textContent = [
      '[data-tgem-sticky] .tgem-sticky__title,',
      '[data-tgem-sticky] .tgem-sticky__title span,',
      '#tgem-shop-sticky .tgem-ss__title,',
      '#tgem-shop-sticky .title{color:#f5f5f5!important;-webkit-text-fill-color:#f5f5f5!important}',
      '[data-tgem-sticky] .tgem-sticky__price,',
      '#tgem-shop-sticky .price{color:#a3a3a3!important;-webkit-text-fill-color:#a3a3a3!important}',
      '[data-tgem-sticky] .tgem-sticky__price strong,',
      '#tgem-shop-sticky .price strong{color:#d4b483!important;-webkit-text-fill-color:#d4b483!important}',
      '[data-tgem-sticky] .tgem-sticky__was,',
      '#tgem-shop-sticky .was{color:#a3a3a3!important;-webkit-text-fill-color:#a3a3a3!important;opacity:1!important;text-decoration:line-through}',
      '[data-tgem-sticky] .tgem-sticky__inner{grid-template-columns:auto 1fr auto!important}',
      '[data-tgem-sticky] .tgem-sticky__thumb,#tgem-shop-sticky .thumb{width:48px;height:48px;border-radius:4px;overflow:hidden;background:#2a2a2a;flex-shrink:0}',
      '[data-tgem-sticky] .tgem-sticky__thumb img,#tgem-shop-sticky .thumb img{display:block;width:100%;height:100%;object-fit:cover}',
      '@media (max-width:520px){[data-tgem-sticky] .tgem-sticky__inner{grid-template-columns:auto 1fr!important}[data-tgem-sticky] .tgem-sticky__cta{grid-column:1/-1;width:100%}}'
    ].join('');
    document.head.appendChild(style);
  }

  function demoteHeroAutoplay() {
    if (isGemLanding() || document.querySelector('[data-tgem-buy] [data-tgem-hero-video]')) return;
    var vids = document.querySelectorAll(
      '.titanore-gem-siraat .tgem-hero__media video, .section-titanore-gem-buybox .tgem-hero__media video, [data-tgem-hero-video]'
    );
    vids.forEach(function (vid) {
      if (vid.getAttribute('data-ss-hero') === '1') return;
      vid.setAttribute('data-ss-hero', '1');
      try {
        vid.removeAttribute('autoplay');
        vid.autoplay = false;
        vid.preload = 'none';
        vid.pause();
      } catch (e) {}
    });
  }

  function ensureNativeStickyThumb() {
    var sticky = document.querySelector('[data-tgem-sticky]');
    if (!sticky || sticky.querySelector('[data-tgem-sticky-img]')) return;
    var inner = sticky.querySelector('.tgem-sticky__inner');
    if (!inner) return;
    var wrap = document.createElement('div');
    wrap.className = 'tgem-sticky__thumb';
    wrap.setAttribute('aria-hidden', 'true');
    var img = document.createElement('img');
    img.setAttribute('data-tgem-sticky-img', '');
    img.src = IMG.medium;
    img.alt = '';
    img.width = 48;
    img.height = 48;
    img.loading = 'lazy';
    img.decoding = 'async';
    wrap.appendChild(img);
    inner.insertBefore(wrap, inner.firstChild);
    document.querySelectorAll('.tgem-size[data-size], [data-size]').forEach(function (el) {
      if (el.getAttribute('data-ss-thumb') === '1') return;
      el.setAttribute('data-ss-thumb', '1');
      el.addEventListener('click', function () {
        var key = el.getAttribute('data-size');
        var src = el.getAttribute('data-img') || IMG[key] || IMG.medium;
        var target = sticky.querySelector('[data-tgem-sticky-img]');
        if (target && src) target.src = src;
      });
    });
  }

  function currentLang() {
    var p = (location.pathname || '').toLowerCase();
    if (p === '/nl' || p.indexOf('/nl/') === 0) return 'nl';
    try {
      if (window.Weglot && typeof Weglot.getCurrentLang === 'function') {
        var wg = Weglot.getCurrentLang();
        if (wg) return wg;
      }
    } catch (e) {}
    var m = document.cookie.match(/(?:^|; )wglang=([^;]+)/);
    if (m) return decodeURIComponent(m[1]);
    return 'en';
  }

  function selectedSizeKey() {
    if (forcedSizeKey && CATALOG[forcedSizeKey]) return forcedSizeKey;
    if (sizeSyncEnabled) {
      var sel = document.querySelector('.tgem-size.is-selected, [data-size].is-selected');
      var key = sel && sel.getAttribute('data-size');
      if (key && CATALOG[key]) return key;
    }
    return 'medium';
  }

  function selected() {
    if (forcedSetKey && SET_CATALOG[forcedSetKey]) return SET_CATALOG[forcedSetKey];
    return CATALOG[selectedSizeKey()];
  }

  function findDrawerHost() {
    return (
      document.querySelector('cart-drawer') ||
      document.querySelector('#CartDrawer') ||
      document.querySelector('[id*="cart-drawer" i]') ||
      document.querySelector('.cart-drawer')
    );
  }

  function replaceDrawerHtml(html) {
    if (!html) return false;
    var wrap = document.createElement('div');
    wrap.innerHTML = String(html).trim();
    var next =
      wrap.querySelector('cart-drawer') ||
      wrap.querySelector('#shopify-section-cart-drawer') ||
      wrap.querySelector('#CartDrawer') ||
      wrap.firstElementChild;
    if (!next) return false;
    var host = findDrawerHost();
    if (!host) return false;
    var section = host.closest('.shopify-section') || host;
    if (next.id && next.id.indexOf('shopify-section') === 0 && section.classList.contains('shopify-section')) {
      section.outerHTML = next.outerHTML;
    } else if (host.tagName && host.tagName.toLowerCase() === 'cart-drawer') {
      host.outerHTML = (wrap.querySelector('cart-drawer') || next).outerHTML;
    } else {
      host.innerHTML = next.innerHTML || next.outerHTML;
    }
    var drawer = findDrawerHost();
    if (drawer) {
      drawer.classList.remove('is-empty');
      if (typeof drawer.open === 'function') drawer.open();
      else {
        drawer.classList.add('active', 'is-open', 'animate');
        document.body.classList.add('overflow-hidden');
      }
      return true;
    }
    return false;
  }

  function addToCart(btn, item) {
    if (!btn || btn.disabled || !item) return;
    var prev = btn.textContent;
    btn.disabled = true;
    btn.textContent = currentLang() === 'nl' ? 'Bezig…' : 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: item.variantId, quantity: 1 }],
        sections: CART_SECTION,
        sections_url: window.location.pathname
      })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add_failed');
        return r.json();
      })
      .then(function (data) {
        if (typeof window.tlShouldSkipToCheckout === 'function' ? window.tlShouldSkipToCheckout() : (typeof window.tlIsMetaWebView === 'function' && window.tlIsMetaWebView())) {
          window.location.assign(typeof window.tlCheckoutHref === 'function' ? window.tlCheckoutHref() : '/nl/checkout?skip_shop_pay=true');
          return;
        }
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh'));
        if (data && data.sections && data.sections[CART_SECTION]) {
          if (replaceDrawerHtml(data.sections[CART_SECTION])) {
            btn.disabled = false;
            btn.textContent = prev;
            return;
          }
        }
        window.location.href = '/cart';
      })
      .catch(function () {
        window.location.href = item.href + (window.location.search || '');
      });
  }

  function hideThemeProductSticky() {
    if (document.getElementById('tgem-hide-theme-sticky')) return;
    var style = document.createElement('style');
    style.id = 'tgem-hide-theme-sticky';
    style.textContent =
      '#stickyAddToCart,[data-sticky-add-to-cart]{display:none!important;visibility:hidden!important;pointer-events:none!important}';
    document.head.appendChild(style);
  }

  function injectStyles() {
    if (document.getElementById('tgem-shop-sticky-css')) return;
    var style = document.createElement('style');
    style.id = 'tgem-shop-sticky-css';
    style.textContent = [
      '#tgem-shop-sticky{position:fixed;left:0;right:0;bottom:0;z-index:99990;padding:12px 16px calc(12px + env(safe-area-inset-bottom));background:rgba(28,28,28,.96);border-top:1px solid rgba(252,250,246,.12);backdrop-filter:blur(12px);-webkit-backdrop-filter:blur(12px);transform:translateY(110%);transition:transform 220ms ease;pointer-events:none;font-family:Inter,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif}',
      '#tgem-shop-sticky.is-on{transform:translateY(0);pointer-events:auto}',
      '#tgem-shop-sticky .inner{width:min(100%,720px);margin:0 auto;display:grid;grid-template-columns:auto 1fr auto;gap:12px;align-items:center}',
      '#tgem-shop-sticky .thumb{width:48px;height:48px;border-radius:4px;overflow:hidden;background:#2a2a2a}',
      '#tgem-shop-sticky .thumb img{display:block;width:100%;height:100%;object-fit:cover}',
      '#tgem-shop-sticky .tgem-ss__title{margin:0;font-size:14px;font-weight:600;line-height:1.25;color:#f5f5f5!important;-webkit-text-fill-color:#f5f5f5!important}',
      '#tgem-shop-sticky .price{margin:4px 0 0;font-size:12px;line-height:1.3;color:#a3a3a3!important;-webkit-text-fill-color:#a3a3a3!important;font-variant-numeric:tabular-nums;display:flex;flex-wrap:wrap;align-items:center;column-gap:12px;row-gap:4px}',
      '#tgem-shop-sticky .price strong{color:#d4b483!important;-webkit-text-fill-color:#d4b483!important;font-weight:700}',
      '#tgem-shop-sticky .was{text-decoration:line-through;color:#a3a3a3!important;-webkit-text-fill-color:#a3a3a3!important;opacity:1!important;margin-left:0}',
      '#tgem-shop-sticky .tl-summer-chip{display:inline-block;margin-left:0;padding:2px 6px;border:1px solid rgba(212,180,131,.7);color:#d4b483;font-size:10px;font-weight:700;letter-spacing:.04em;text-transform:uppercase;vertical-align:middle;flex-shrink:0}',
      '#tgem-shop-sticky .cta{appearance:none;border:0;min-height:44px;padding:12px 18px;background:#fcfaf6;color:#1c1c1c;font:inherit;font-size:13px;font-weight:700;letter-spacing:.04em;text-transform:uppercase;border-radius:2px;cursor:pointer;white-space:nowrap}',
      '#tgem-shop-sticky .cta:disabled{opacity:.65;cursor:wait}',
      '#tgem-shop-sticky .cta:focus-visible{outline:2px solid #d4b483;outline-offset:2px}',
      'body.tgem-shop-sticky-pad{padding-bottom:88px}',
      'body.tgem-shop-sticky-pad .weglot-container.wg-default{bottom:96px!important}',
      '@media (max-width:520px){#tgem-shop-sticky .inner{grid-template-columns:auto 1fr;gap:10px 12px}#tgem-shop-sticky .cta{grid-column:1/-1;width:100%}}',
      '@media (prefers-reduced-motion:reduce){#tgem-shop-sticky{transition:none}}',
      '.titanore-gem-siraat .tgem-cta,.section-titanore-gem-buybox .tgem-cta{display:inline-flex!important;align-items:center;justify-content:center;width:100%;min-height:52px;padding:16px 20px;background:#1c1c1c!important;color:#fff!important;text-decoration:none;font-size:13px;font-weight:700;letter-spacing:.08em;text-transform:uppercase;border:0;border-radius:2px;cursor:pointer}'
    ].join('');
    document.head.appendChild(style);
  }

  function stickyCtaLabel() {
    if (currentLang() === 'nl') return forcedSetKey ? 'Set in winkelwagen' : 'In winkelwagen';
    return forcedSetKey ? 'Add set to cart' : 'Add to cart';
  }

  function ensureSticky() {
    if (document.getElementById('tgem-shop-sticky')) return document.getElementById('tgem-shop-sticky');
    var item = selected();
    var titleEn = item.title || 'Chef’s Pan';
    var titleNl = item.titleNl || titleEn;
    var titleNow = currentLang() === 'nl' ? titleNl : titleEn;
    var bar = document.createElement('div');
    bar.id = 'tgem-shop-sticky';
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', forcedSetKey ? 'Buy Chef’s Pan set' : 'Buy Chef’s Pan');
    bar.setAttribute('data-tl-sitewide-sticky', '1');
    bar.innerHTML =
      '<div class="inner">' +
        '<div class="thumb" aria-hidden="true"><img data-ss-img src="' +
        item.img +
        '" alt="" width="48" height="48" loading="lazy" decoding="async"></div>' +
        '<div>' +
          '<p class="tgem-ss__title" data-wg-notranslate translate="no">' +
          '<span data-ss-title data-en="' +
          titleEn +
          '" data-nl="' +
          titleNl +
          '">' +
          titleNow +
          '</span>' +
          ' · <span data-ss-label translate="no" data-wg-notranslate>' +
          item.label +
          '</span></p>' +
          '<p class="price"><strong data-ss-price>' +
          item.price +
          '</strong><span class="was" data-ss-was>' +
          item.was +
          '</span><span class="tl-summer-chip" data-ss-chip>' +
          (item.chip || '40% SUMMER DISCOUNT') +
          '</span></p>' +
          (item.gift
            ? ''
            : '') +
        '</div>' +
        '<button type="button" class="cta" data-ss-cta data-en="' +
        (forcedSetKey ? 'Add set to cart' : 'Add to cart') +
        '" data-nl="' +
        (forcedSetKey ? 'Set in winkelwagen' : 'In winkelwagen') +
        '">' +
        stickyCtaLabel() +
        '</button>' +
      '</div>';
    document.body.appendChild(bar);
    bar.querySelector('[data-ss-cta]').addEventListener('click', function () {
      addToCart(bar.querySelector('[data-ss-cta]'), selected());
    });
    return bar;
  }

  function syncSticky(bar) {
    if (!bar) return;
    var item = selected();
    var titleEl = bar.querySelector('[data-ss-title]');
    var label = bar.querySelector('[data-ss-label]');
    var price = bar.querySelector('[data-ss-price]');
    var was = bar.querySelector('[data-ss-was]');
    var img = bar.querySelector('[data-ss-img]');
    var cta = bar.querySelector('[data-ss-cta]');
    if (titleEl) {
      var tEn = item.title || titleEl.getAttribute('data-en') || 'Chef’s Pan';
      var tNl = item.titleNl || tEn;
      titleEl.setAttribute('data-en', tEn);
      titleEl.setAttribute('data-nl', tNl);
      titleEl.textContent = currentLang() === 'nl' ? tNl : tEn;
    }
    if (label) label.textContent = item.label;
    if (price) price.textContent = item.price;
    if (was) was.textContent = item.was;
    if (img && item.img) img.src = item.img;
    if (cta && !cta.disabled) {
      cta.textContent = stickyCtaLabel();
    }
  }

  function findPrimaryAtcTrigger() {
    return (
      document.querySelector('#tl-pan-buybox [data-cta], #tl-pan-buybox .tl-cta') ||
      document.querySelector('[data-tgem-cta], .tgem-cta') ||
      document.querySelector('.tgem-summary') ||
      document.querySelector(
        'form[action*="/cart/add"] [type="submit"], form[action*="/cart/add"] button[name="add"], button[name="add"], .product-form__submit, [data-product-form] button[type="submit"]'
      )
    );
  }

  function bindStickyVisibility(bar) {
    function privacyOpen() {
      if (document.documentElement.classList.contains('tl-privacy-banner-open')) return true;
      if (typeof window.__tlCookieBannerOpen === 'function') return window.__tlCookieBannerOpen();
      return !!(document.getElementById('shopify-pc__banner') || document.getElementById('shopify-pc__prefs'));
    }
    var trigger = findPrimaryAtcTrigger();
    if (!trigger || !('IntersectionObserver' in window)) {
      if (!privacyOpen()) {
        bar.classList.add('is-on');
        document.body.classList.add('tgem-shop-sticky-pad');
      }
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        if (privacyOpen()) {
          bar.classList.remove('is-on');
          document.body.classList.remove('tgem-shop-sticky-pad');
          return;
        }
        var show = entries[0] && !entries[0].isIntersecting;
        bar.classList.toggle('is-on', show);
        document.body.classList.toggle('tgem-shop-sticky-pad', show);
      },
      { threshold: 0, rootMargin: '-8px 0px 0px 0px' }
    );
    io.observe(trigger);
  }

  function upgradePrimaryCta() {
    if (!isGemLanding()) return;
    var cta = document.querySelector('[data-tgem-cta], a.tgem-cta, button.tgem-cta');
    if (!cta || cta.getAttribute('data-ss-bound') === '1') return;
    cta.setAttribute('data-ss-bound', '1');

    function labelFor() {
      return currentLang() === 'nl' ? 'Koop de Chef’s Pan' : 'Shop the Chef’s Pan';
    }

    if (cta.tagName === 'A') {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = cta.className || 'tgem-cta';
      btn.setAttribute('data-tgem-cta', '');
      btn.setAttribute('data-tgem-atc', '');
      btn.setAttribute('data-ss-bound', '1');
      btn.setAttribute('data-en', 'Shop the Chef’s Pan');
      btn.setAttribute('data-nl', 'Koop de Chef’s Pan');
      btn.textContent = labelFor();
      cta.parentNode.insertBefore(btn, cta);
      cta.remove();
      cta = btn;
    } else {
      cta.textContent = labelFor();
    }

    cta.addEventListener('click', function (e) {
      e.preventDefault();
      addToCart(cta, selected());
    });
  }

  function bindSizeCards(bar) {
    if (!sizeSyncEnabled) return;
    document.querySelectorAll('.tgem-size, [data-size]').forEach(function (el) {
      if (el.getAttribute('data-ss-size') === '1') return;
      el.setAttribute('data-ss-size', '1');
      el.addEventListener('click', function () {
        setTimeout(function () {
          syncSticky(bar);
          var pdp = document.querySelector('[data-ss-pdp], [data-tgem-pdp-link]');
          if (pdp) pdp.href = selected().href;
        }, 0);
      });
    });
  }

  function resolveMode() {
    var setKey = pdpSetFromPath();
    if (setKey) {
      forcedSetKey = setKey;
      forcedSizeKey = null;
      sizeSyncEnabled = false;
      return 'set';
    }
    forcedSetKey = null;
    var pdp = pdpSizeFromPath();
    if (pdp) {
      forcedSizeKey = pdp;
      sizeSyncEnabled = false;
      return 'pdp';
    }
    if (
      isGemLanding() ||
      document.querySelector('.titanore-gem-siraat, .section-titanore-gem-buybox, .tgem-size[data-size]')
    ) {
      sizeSyncEnabled = !!document.querySelector('.tgem-size[data-size], [data-size].tgem-size');
      if (!sizeSyncEnabled && document.querySelector('[data-size]')) {
        sizeSyncEnabled = true;
      }
      forcedSizeKey = null;
      return 'gem';
    }
    forcedSizeKey = 'medium';
    sizeSyncEnabled = false;
    return 'default';
  }

  function init() {
    hydrateCatalogFromBuybox();
    injectContrastFix();
    demoteHeroAutoplay();
    ensureNativeStickyThumb();

    /* Native GEM sticky owns the bar — contrast/thumb only */
    if (document.querySelector('[data-tgem-sticky]')) {
      return;
    }

    resolveMode();

    var existing = document.getElementById('tgem-shop-sticky');
    if (existing) {
      /* Legacy global-atc-bar / older sitewide may have defaulted to Medium on set PDPs */
      if (forcedSetKey) {
        existing.remove();
      } else {
        return;
      }
    }

    hideThemeProductSticky();
    injectStyles();
    if (isGemLanding()) upgradePrimaryCta();
    var bar = ensureSticky();
    syncSticky(bar);
    bindStickyVisibility(bar);
    bindSizeCards(bar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  setTimeout(init, 400);
  setTimeout(init, 1200);
})();

/* cityhash-bust 1786751600-size-tiles-king25 */

/* king-skill: repair single-pan PDP buybox when page_cache still loads inject v21.
   Do NOT polish sticky labels on set PDPs (would overwrite Small + Medium). */
(function () {
  var path = (window.location.pathname || '').toLowerCase();
  var isPanPdp = /titanium-hammered-pan-pro-(small|medium|large)/.test(path);
  var isSetPdp = /chefs-pan-set-[23]/.test(path);
  if (!isPanPdp && !isSetPdp) return;

  var KING_SRC = '';

  function isKingBox(box) {
    if (!box) return false;
    if (box.getAttribute('data-v') === '22-king') return true;
    var t = box.textContent || '';
    return /Nothing to wear off|Geen coating|Niets dat slijt/.test(t);
  }

  function poisonOldInject() {
    var box = document.getElementById('tl-pan-buybox');
    if (!isKingBox(box)) return;
    var ver = box.getAttribute('data-v') || '';
    if (/^4[0-9]/.test(ver)) return;
    /* Legacy inject BOX_VERSION=21 skips replace when data-v matches + [data-slots] */
    box.setAttribute('data-v', '21');
    box.setAttribute('data-tl-ready', '1');
  }

  function polishSticky() {
    if (!isPanPdp) return;
    var map = { small: 'Small · 26 cm', medium: 'Medium · 28 cm', large: 'Large · 30 cm' };
    var key = /small/.test(path) ? 'small' : /large/.test(path) ? 'large' : 'medium';
    document.querySelectorAll('#tgem-shop-sticky [data-ss-label], [data-tgem-sticky] [data-ss-label]').forEach(function (el) {
      el.textContent = map[key];
      el.setAttribute('data-wg-notranslate', '');
      el.setAttribute('translate', 'no');
    });
  }

  function loadKing() {
    /* Theme loads king25. Do not inject leftover king24. */
    if (!isPanPdp) return;
    poisonOldInject();
  }

  function boot() {
    loadKing();
    polishSticky();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  setTimeout(boot, 200);
  setTimeout(boot, 700);
  setTimeout(boot, 1400);
  setTimeout(boot, 2200);
})();

/* tl-hero-vb-boot */
(function(){try{var p=(location.pathname||'').toLowerCase();if(!(p.indexOf('/pages/shop-chefs-pan')===0||p.indexOf('/pages/buy-chefs-pan')===0||p.indexOf('/pages/chefs-pan')===0||p.indexOf('/nl/pages/shop-chefs-pan')===0||p.indexOf('/nl/pages/buy-chefs-pan')===0||p.indexOf('/nl/pages/chefs-pan')===0))return;var s=document.createElement('script');s.src='https://cdn.shopify.com/s/files/1/1009/4254/5283/t/16/assets/titanore-hero-video-behind.js?v=truehires2';s.defer=true;document.head.appendChild(s);}catch(e){}})();
/* bust-1786413873 */


/* tl-hero-lift-inject-20260811c */
(function(){try{var path=(location.pathname||'').toLowerCase();if(!(/\/pages\/(buy-chefs-pan|chefs-pan|shop-chefs-pan|chefs-pan-buy)/.test(path)||/\/nl\/pages\/(buy-chefs-pan|chefs-pan|shop-chefs-pan|chefs-pan-buy)/.test(path)))return;var css="[data-tgem-buy] .tgem-hero__media img,[data-tgem-buy] .tgem-hero__media video{filter:brightness(1.22) contrast(1.06)!important}[data-tgem-buy] .tgem-hero::after{background:linear-gradient(180deg,rgba(0,0,0,.08) 0%,rgba(0,0,0,.14) 42%,rgba(0,0,0,.52) 78%,rgba(0,0,0,.68) 100%)!important}@media (min-width:900px){[data-tgem-buy] .tgem-hero::after{background:linear-gradient(90deg,rgba(0,0,0,.55) 0%,rgba(0,0,0,.28) 36%,rgba(0,0,0,.08) 62%,rgba(0,0,0,0) 100%),linear-gradient(180deg,rgba(0,0,0,.08) 0%,rgba(0,0,0,.04) 50%,rgba(0,0,0,.32) 100%)!important}}";var s=document.getElementById("tl-hero-lift-live");if(!s){s=document.createElement("style");s.id="tl-hero-lift-live";(document.documentElement||document.head).appendChild(s);}s.textContent=css;function fixSale(){var sale=document.querySelector(".titanore-offer-bar .tob-sale");if(sale){sale.querySelectorAll(".tob-mark").forEach(function(m){m.remove();});sale.textContent="40% SUMMER DISCOUNT";}document.querySelectorAll("#okhSummerStrip,#tlSummerStripLive").forEach(function(el){el.remove();});}fixSale();setTimeout(fixSale,400);setTimeout(fixSale,1200);}catch(e){}})();

/* tl-desk-ipad-20260814 — unlock mobile buybox width when page_cache is stale */
(function () {
  try {
    var p = (location.pathname || '').toLowerCase();
    if (
      p !== '/pages/chefs-pan-now' &&
      p !== '/nl/pages/chefs-pan-now' &&
      p !== '/pages/chefs-pan' &&
      p !== '/nl/pages/chefs-pan' &&
      p !== '/pages/buy-chefs-pan' &&
      p !== '/nl/pages/buy-chefs-pan' &&
      p !== '/pages/get-chefs-pan' &&
      p !== '/nl/pages/get-chefs-pan' &&
      p !== '/pages/chefs-pan-buy' &&
      p !== '/nl/pages/chefs-pan-buy'
    ) {
      return;
    }
    if (window.__tlDeskIpadBoot) return;
    window.__tlDeskIpadBoot = 1;
    var s = document.createElement('script');
    s.src =
      'https://cdn.shopify.com/s/files/1/1009/4254/5283/t/16/assets/titanore-hero-video-behind.js?v=truehires2';
    s.defer = true;
    (document.head || document.documentElement).appendChild(s);
  } catch (e) {}
})();
